import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// import Header from "../components/common/header/Header";
// import { Card, Box } from "@mui/material";
// import Login from "../components/login/login";
// import Verify from "../components/common/Verify/Verify";
import DashboardLayout from "../layouts/DashboardLayout";

import Dashboard from "../components/dashboard/Dashboard";

import Services from "../components/services/Services";

import Aboutus from "../components/aboutus/Aboutus";

import Contactme from "../components/contactme/Contactme";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<DashboardLayout />}>
          <Route index element={<Dashboard />} />
        </Route>
        <Route path="/services" element={<DashboardLayout />}>
          <Route index element={<Services />} />
        </Route>
        <Route path="/aboutus" element={<DashboardLayout />}>
          <Route index element={<Aboutus />} />
        </Route>
        <Route path="/contactme" element={<DashboardLayout />}>
          <Route index element={<Contactme />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
